var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _g4, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 200,
    viewBox: "0 0 273 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.602 62.5C69.679 62.5 81.9013 51.3071 81.9013 37.5C81.9013 23.6929 69.679 12.5 54.602 12.5C39.525 12.5 27.3027 23.6929 27.3027 37.5C27.3027 51.3071 39.525 62.5 54.602 62.5Z",
    fill: "#F0F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M218.398 81.25C237.244 81.25 252.522 67.2589 252.522 50C252.522 32.7411 237.244 18.75 218.398 18.75C199.552 18.75 184.274 32.7411 184.274 50C184.274 67.2589 199.552 81.25 218.398 81.25Z",
    fill: "#FFF9E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M232.048 146.875C245.24 146.875 255.934 137.081 255.934 125C255.934 112.919 245.24 103.125 232.048 103.125C218.855 103.125 208.161 112.919 208.161 125C208.161 137.081 218.855 146.875 232.048 146.875Z",
    fill: "#E8F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.847 68.75H107.153C102.63 68.75 98.9634 72.1079 98.9634 76.25V142.5C98.9634 146.642 102.63 150 107.153 150H165.847C170.37 150 174.036 146.642 174.036 142.5V76.25C174.036 72.1079 170.37 68.75 165.847 68.75Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.71094
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9634 87.5H174.036M98.9634 106.25H174.036M98.9634 125H174.036M119.438 68.75V150M139.912 68.75V150M160.387 68.75V150",
    stroke: "#F1F5F9",
    strokeWidth: 0.684375
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.613 137.5L126.263 118.75L153.562 125L160.387 93.75",
    stroke: "#CBD5E1",
    strokeWidth: 2.05312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.613 140C114.121 140 115.343 138.881 115.343 137.5C115.343 136.119 114.121 135 112.613 135C111.106 135 109.883 136.119 109.883 137.5C109.883 138.881 111.106 140 112.613 140Z",
    fill: "white",
    stroke: "#94A3B8",
    strokeWidth: 1.02656
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.387 96.25C161.895 96.25 163.117 95.1307 163.117 93.75C163.117 92.3693 161.895 91.25 160.387 91.25C158.879 91.25 157.657 92.3693 157.657 93.75C157.657 95.1307 158.879 96.25 160.387 96.25Z",
    fill: "white",
    stroke: "#94A3B8",
    strokeWidth: 1.02656
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.453 75H111.248C110.117 75 109.201 75.8395 109.201 76.875C109.201 77.9105 110.117 78.75 111.248 78.75H134.453C135.583 78.75 136.5 77.9105 136.5 76.875C136.5 75.8395 135.583 75 134.453 75Z",
    fill: "#E2E8F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 116.633C141.515 116.633 145.581 112.909 145.581 108.316C145.581 103.723 141.515 100 136.5 100C131.485 100 127.419 103.723 127.419 108.316C127.419 112.909 131.485 116.633 136.5 116.633Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.21417
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.256 104.355C134.345 104.355 132.844 105.73 132.844 107.48C132.844 109.855 136.256 112.48 136.256 112.48C136.256 112.48 139.668 109.855 139.668 107.48C139.668 105.73 138.167 104.355 136.256 104.355Z",
    stroke: "#94A3B8",
    strokeWidth: 1.02656
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2518 71.875C68.2518 63.2456 60.6129 56.25 51.1897 56.25C41.7666 56.25 34.1277 63.2456 34.1277 71.875C34.1277 80.5044 41.7666 87.5 51.1897 87.5C60.6129 87.5 68.2518 80.5044 68.2518 71.875Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.36875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0158 67.4556L49.7422 79.388L48.2944 74.5267L42.9859 73.2008L56.0158 67.4556Z",
    fill: "#93C5FD",
    stroke: "#3B82F6",
    strokeWidth: 1.02656,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.237 50H203.383C200.368 50 197.923 52.2386 197.923 55V76.25C197.923 79.0114 200.368 81.25 203.383 81.25H240.237C243.253 81.25 245.697 79.0114 245.697 76.25V55C245.697 52.2386 243.253 50 240.237 50Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.36875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.668 56.25H207.478C205.971 56.25 204.748 57.3693 204.748 58.75C204.748 60.1307 205.971 61.25 207.478 61.25H215.668C217.176 61.25 218.398 60.1307 218.398 58.75C218.398 57.3693 217.176 56.25 215.668 56.25Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.507 65.625H206.113C205.359 65.625 204.748 66.1846 204.748 66.875C204.748 67.5654 205.359 68.125 206.113 68.125H237.507C238.261 68.125 238.872 67.5654 238.872 66.875C238.872 66.1846 238.261 65.625 237.507 65.625Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.858 71.25H206.113C205.359 71.25 204.748 71.8096 204.748 72.5C204.748 73.1904 205.359 73.75 206.113 73.75H223.858C224.612 73.75 225.223 73.1904 225.223 72.5C225.223 71.8096 224.612 71.25 223.858 71.25Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46 61.875C236.968 61.875 238.19 60.7557 238.19 59.375C238.19 57.9943 236.968 56.875 235.46 56.875C233.952 56.875 232.73 57.9943 232.73 59.375C232.73 60.7557 233.952 61.875 235.46 61.875Z",
    fill: "#FDE68A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8393 131.25H47.7772C44.008 131.25 40.9524 134.048 40.9524 137.5V153.125C40.9524 156.577 44.008 159.375 47.7772 159.375H64.8393C68.6085 159.375 71.6641 156.577 71.6641 153.125V137.5C71.6641 134.048 68.6085 131.25 64.8393 131.25Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.36875
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M56.3085 138.75C54.0563 138.75 52.2136 140.437 52.2136 142.5C52.2136 145.312 56.3085 150 56.3085 150C56.3085 150 60.4034 145.312 60.4034 142.5C60.4034 140.437 58.5607 138.75 56.3085 138.75Z",
    fill: "#FDE68A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3083 144.062C57.2506 144.062 58.0145 143.363 58.0145 142.5C58.0145 141.637 57.2506 140.938 56.3083 140.938C55.3659 140.938 54.6021 141.637 54.6021 142.5C54.6021 143.363 55.3659 144.062 56.3083 144.062Z",
    fill: "#F59E0B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.237 137.5H210.208C207.193 137.5 204.748 139.739 204.748 142.5V163.75C204.748 166.511 207.193 168.75 210.208 168.75H240.237C243.253 168.75 245.697 166.511 245.697 163.75V142.5C245.697 139.739 243.253 137.5 240.237 137.5Z",
    fill: "white",
    stroke: "#CBD5E1",
    strokeWidth: 1.36875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.573 162.5L218.398 153.125L228.635 157.5L238.872 146.875",
    stroke: "#93C5FD",
    strokeWidth: 1.36875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.872 148.125C239.626 148.125 240.237 147.565 240.237 146.875C240.237 146.185 239.626 145.625 238.872 145.625C238.118 145.625 237.507 146.185 237.507 146.875C237.507 147.565 238.118 148.125 238.872 148.125Z",
    fill: "#3B82F6"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.9012 45.625C83.032 45.625 83.9487 44.7855 83.9487 43.75C83.9487 42.7145 83.032 41.875 81.9012 41.875C80.7704 41.875 79.8538 42.7145 79.8538 43.75C79.8538 44.7855 80.7704 45.625 81.9012 45.625Z",
    fill: "#93C5FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M184.274 102.5C185.782 102.5 187.004 101.381 187.004 100C187.004 98.6193 185.782 97.5 184.274 97.5C182.766 97.5 181.544 98.6193 181.544 100C181.544 101.381 182.766 102.5 184.274 102.5Z",
    fill: "#FDE68A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.376 164.062C103.318 164.062 104.082 163.363 104.082 162.5C104.082 161.637 103.318 160.938 102.376 160.938C101.434 160.938 100.67 161.637 100.67 162.5C100.67 163.363 101.434 164.062 102.376 164.062Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRoute);
export default __webpack_public_path__ + "static/media/NoRoute.d2d33bd1a18500bcd17baeb40d640e61.svg";
export { ForwardRef as ReactComponent };